import { WbPopover } from '@workbench/react';
import './EquipmentImageCard.scss';

function EquipmentImageCard({ url, title, imageType }) {
	const download = () => {
		const link = document.createElement('a');
		link.href = url;
		link.download = `${title}.${imageType}`;
		link.click();
	};

	const handleDownloadKeyDown = (event) => {
		if (event.key !== 'Enter' && event.key !== ' ') return;
		event.preventDefault();
		download();
	};

	return (
		<WbPopover position="top">
			<div
				className="vimdt-equipment-card"
				role="button"
				tabIndex={0}
				onClick={download}
				onKeyDown={handleDownloadKeyDown}
			>
				<img className="vimdt-equipment-card__image" src={url} alt={title} />
				<div className="vimdt-equipment-card__title">{title}</div>
			</div>
			<div slot="content" className="vimdt-equipment-card__popover">
				<strong>{title}</strong>
				<img src={url} alt={title} />
			</div>
		</WbPopover>
	);
}

export default EquipmentImageCard;
